import { Result } from 'domain/types';
import UpdateLayoutClient from 'use-case/layout/update/updateLayoutClient';
import UpdateLayoutCriteria from 'use-case/layout/update/updateLayoutCriteria';
import Layout from 'domain/entity/layout';

export type UpdateLayoutResult = Result<Layout>;
export type UpdateLayout = (criteria: UpdateLayoutCriteria) => Promise<UpdateLayoutResult>;

const updateLayoutUseCase = (updateLayoutClient: UpdateLayoutClient): UpdateLayout => (
    criteria: UpdateLayoutCriteria
): Promise<UpdateLayoutResult> => updateLayoutClient(criteria);

export default updateLayoutUseCase;
